<template>
  <svg
    v-if="color === 'default'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.0001 24L19.1819 21.8182L9.3637 12L19.1819 2.18182L17.0001 0L5.00007 12L17.0001 24Z"
      fill="#121212"
    />
  </svg>
  <svg
    v-else-if="color === 'primary'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.0001 24L19.1819 21.8182L9.3637 12L19.1819 2.18182L17.0001 0L5.00007 12L17.0001 24Z"
      fill="var(--brandPrimary)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      default: "default",
    },
  },
};
</script>
